import i18n from 'src/i18n'
import { useAICommentSuggestions } from '../useAICommentSuggestions'
import { getDefaultSuggestions } from '../../utils'
import { UseCommentSuggestionsProps } from './useCommentSuggestions.types'

const useCommentSuggestions = ({ enabledIA: enabled }: UseCommentSuggestionsProps) => {
  const { loading, aISuggestions } = useAICommentSuggestions({ enabled })
  const hasValidAISuggestions = Array.isArray(aISuggestions) && aISuggestions.length > 0
  const defaultSuggestions = getDefaultSuggestions(i18n)

  if (!enabled) {
    return {
      loading: false,
      suggestions: defaultSuggestions
    }
  }

  return {
    loading,
    suggestions: hasValidAISuggestions ? aISuggestions : defaultSuggestions
  }
}

export default useCommentSuggestions
